if (!customElements.get('gang-proof')) {
  customElements.define(
    'gang-proof',
    class GangProof extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (this.hasAttribute('data-fixed')) return;

        const productInfo = this.closest('product-info');
        const sectionId =
          productInfo?.dataset.originalSection || productInfo?.dataset.section || this.dataset.sectionId;

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== sectionId || !event.data.variant) return;

          const amounts = this.querySelectorAll('[data-gang-proof-amount]');
          if (!amounts.length) return;

          const proof = String(Math.ceil((event.data.variant.price / 100) * Number(this.dataset.proofRate)));
          amounts.forEach((amount) => {
            amount.textContent = proof;
          });
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }
    }
  );
}
